import { Button } from '@fox/atoms';
import styled from 'styled-components';
import { useContentContext } from '../content-context';
import { MemberLoginStatus } from '../Membership/login-status';
import { redirect } from '../Membership/membership-form-template/util';
import { ButtonInputModel, LoginStatusButtonInputModel } from './contracts';
import { FlexColumnCentered } from '@fox/layout';

const BurgerButtonsWrapper = styled.div<{ numberOfButtons: number }>`
	display: flex;
	flex-wrap: wrap;
	row-gap: 1rem;
	padding-bottom: 1rem;
	${props => (props.numberOfButtons === 1 ? 'justify-content: center;' : '')}
`;

const ButtonWrapper = styled.div`
	flex-basis: 50%;
	padding-left: 1rem;
	padding-right: 1rem;
	button {
		width: 100%;
		max-width: 200px;
		.MuiTouchRipple-root {
			inset: auto;
		}
	}
`;

export function BurgerButtons({
	headerButtons,
	loginStatus
}: {
	headerButtons: ButtonInputModel[];
	loginStatus: LoginStatusButtonInputModel[];
}) {
	const { requestToken } = useContentContext();
	return (
		<BurgerButtonsWrapper numberOfButtons={(loginStatus?.length ?? 0) + (headerButtons?.length ?? 0)}>
			{loginStatus?.map((loginButton, i) => {
				return (
					<ButtonWrapper key={'login' + i}>
						<MemberLoginStatus {...loginButton} requestToken={requestToken} />
					</ButtonWrapper>
				);
			})}
			{headerButtons?.map((button, i) => {
				return (
					<ButtonWrapper key={'button' + i}>
						<FlexColumnCentered>
							<Button
								variant={button.variant ?? 'primary'}
								onClick={() => {
									redirect(button.buttonLink);
								}}
								size="large"
							>
								{button.buttonText}
							</Button>
						</FlexColumnCentered>
					</ButtonWrapper>
				);
			})}
		</BurgerButtonsWrapper>
	);
}
